<template>
  <div class="pageDiv">
      <v-card class="main-card">
          <v-card-title>
              <span class="page-title">{{ $AuthSvc.getYear() }} Schedules</span>
          </v-card-title>

          <v-card-text v-if="tournaments.length === 0">
              <span class="label14">
                  No schedules at this time.
              </span>
          </v-card-text>

          <v-card-text class="schedule-card-div"
               v-for="tournament in tournaments" :key="tournament.tournament.tournamentId" >
              <v-card class="schedule-card">
                  <div class="course-img">
                    <v-img class="course-img" :src="'/images/courses/' + tournament.course.image">
                    </v-img>
                  </div>

                  <div class="schedule-info">
                      <div class="name-card" v-if="tournament.tournament.sponsorName===null || tournament.tournament.sponsorName===''">
                          <span class="label18">
                              {{tournament.course.name}} 
                              <div class="major-logo" v-if="tournament.tournament.major==='Y'">
                                  <v-img src="../../assets/img/dfwvga-logo-black-mini.png">
                                  </v-img>
                              </div>
                          </span>
                      </div>

                      <div class="name-card" v-if="tournament.tournament.sponsorName!==null && tournament.tournament.sponsorName!==''">
                          <div>
                              <div>
                                  <span class="label18">
                                      {{tournament.tournament.sponsorName}}
                                  </span>
                                  <span class="major-logo" v-if="tournament.tournament.major==='Y'">
                                  <v-img src="../../assets/img/dfwvga-logo-mini.png">
                                  </v-img>
                              </span>
                              </div>
                          </div>
                          <span class="label14">
                              {{tournament.course.name}} 
                          </span>
                      </div>

                      <span style="font-weight:bold;font-size:20px !important">{{printMonth(tournament.tournament.scheduleDate)}}</span>
                      <br>
                      <div v-if="$AuthSvc.isMobile()">
                          <b>Date: </b> {{tournament.scheduleDate}}<br>
                          <b>Time: </b> {{tournament.scheduleTime}} <span v-if="tournament.tournament.shotgun==='Y'">SHOTGUN</span><br>
                          <b>Deadline: </b> {{printDateTime(tournament.tournament.registrationDeadline)}}<br>
                          <b>Member Fee: </b> ${{getFee(tournament.tournament)}}<br>
                          <b>Guest Fee: </b> ${{tournament.tournament.guestFee}}<br>
                          <b>Location: </b> {{tournament.course.location}}<br>
                          <b>Website: </b><a @click="goTo(tournament)">{{tournament.course.website}}</a><br>
                          <span v-if="tournament.tournament.hole19!==null && tournament.tournament.hole19!==''">
                          <b>19th Hole: </b> {{tournament.tournament.hole19}}</span>
                      </div>
                      <div v-if="!$AuthSvc.isMobile()">
                          <b>Date: </b> {{tournament.scheduleDate}}
                          <b>Time: </b> {{tournament.scheduleTime}} <span v-if="tournament.tournament.shotgun==='Y'">SHOTGUN</span><br>
                          <b>Deadline: </b> {{printDateTime(tournament.tournament.registrationDeadline)}}<br>
                          <b>Member Fee: </b> ${{getFee(tournament.tournament)}}
                          <b>Guest Fee: </b> ${{tournament.tournament.guestFee}}<br>
                          <b>Location: </b> {{tournament.course.location}}<br>
                          <b>Website: </b><a @click="goTo(tournament)">{{tournament.course.website}}</a><br>
                          <span v-if="tournament.tournament.hole19!==null && tournament.tournament.hole19!==''">
                          <b>19th Hole: </b> {{tournament.tournament.hole19}}</span>
                      </div>
                  </div>


                      <div class="card-action">
                          <v-btn v-if="tournament.tournament.status === 'REGISTER'"
                                class="action-button register"
                                @click="register(tournament.tournament)">
                              Register Now
                          </v-btn>
                          <v-btn v-if="tournament.tournament.status === 'REGISTER_COMPLETED'"
                                class="status-button">
                              Generating Group
                          </v-btn>
                          <v-btn v-if="tournament.tournament.status === 'GROUPING'"
                                class="action-button register-complete"
                                @click="pairing(tournament.tournament)">
                              Pairings
                          </v-btn>
                          <v-btn v-if="tournament.tournament.status === 'ACTIVE'"
                                class="action-button results"
                                @click="scoreCard(tournament.tournament)">
                              Score Card
                          </v-btn>
                          <v-btn v-if="tournament.tournament.status === 'REVIEW'"
                                class="action-button results"
                                @click="showResults(tournament.tournament)">
                              Unofficial Results
                          </v-btn>
                          <v-btn  v-if="tournament.tournament.status === 'OFFICIAL'"
                                  class="action-button results"
                                  @click="showResults(tournament.tournament)">
                              Results
                          </v-btn>
                      </div>
              </v-card>
          </v-card-text>
      </v-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "schedule",
  data: () => ({
    LATE_FEE: 0,
    courses: [],
    tournaments: []
  }),
  mounted: function() {
      var _this = this;
      _this.loadSchedule();
  },
  methods: {
    printMonth(date) {
      return moment(date).format('MMMM');
    },
    printDate(date) {
      return moment(date).format('ddd MMMM DD YYYY');
    },
    printTime(date) {
      return moment(date).format('hh:mm A');
    },
    printDateTime(date) {
      return moment(date).format('MMMM DD hh:mm A');
    },
    getFee(tournament) {
      var now = moment();
      if (now.isAfter(tournament.earlyRegisterDeadline)) {
        return Number(tournament.memberFee) + this.LATE_FEE;
      }
      else {
        return tournament.memberFee;
      }
    },
    register(tournament) {
      window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
      if (tournament.formatType === 'BANQUET') {
          window.location.href = '/registration-banquet?id='+tournament.tournamentId;
      }
      else {
          window.location.href = '/registration?id='+tournament.tournamentId;
      }
    },
    pairing(tournament) {
      window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
      window.location.href = '/grouping?id='+tournament.tournamentId;
    },
    scoreCard(tournament) {
      window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
      window.location.href = '/scoring?id='+tournament.tournamentId;
    },
    showResults(tournament) {
      window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
      window.location.href = '/results?id='+tournament.tournamentId;
    },
    goTo(tournament) {
      window.location.href = tournament.course.website;
    },
    loadSchedule() {
        var _this = this;

        _this.axios.get('/public/tournaments/type/TOURNAMENT')
        .then(function (response) {
            _this.tournaments = response.data;
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);f
        });
    }
  }
}
</script>

<style scoped>

.main-card {
  overflow-y: scroll;
  min-height: 800px;
}

.schedule-card-div {
  margin: 5px 0;
  width: 100%;
}

.schedule-card {
  padding: 10px;
  border: 1px #1F0404 solid;
  border-radius: 5px !important;
  width: 480px;
  height: 660px;
}

.course-img {
  border-radius: 5px;
  width: 100%;
  height: 300px;
  object-fit: contain;
}

.name-card {
  height: 60px;
  margin-top:7px;
}

.card-action {
  margin-top: 10px;
}

.card-action > span {
  display: inline-block !important;
}

.card-action > .v-btn {
  display: inline-block !important;
  float: right;
}

.major-logo {
  display: inline-block;
  width: 25px;
  height:25px;
  margin-left: 15px;
}

.action-button {
  font-weight: bold;
  font-size:12px !important;
  background-color: darkgreen !important;
  color: white !important;
  height: 26px;
}

.status-button {
  font-weight: bold;
  font-size:12px !important;
  background-color: cyan !important;
  color: black !important;
  height: 26px;
}

.register {
  background-color: darkgreen !important;
}

.register-complete {
  background-color: green !important;
}

.results {
  background-color: darkred !important;
}

@media (min-width: 768px) {
    .v-card__text {
      font-size: 12px;
    }

    .schedule-card-div {
      margin: 0;
      width: 96% !important;
      min-width: 1280px;
    }

    .schedule-card {
      padding: 10px;
      border: 1px #1F0404 solid;
      border-radius: 5px !important;
      width: 90%;
      height: 270px;
    }

    .course-img {
      display: inline-block;
      float: left;
      border-radius: 5px;
      width: 340px;
      height: 240px;
    }

    .schedule-info {
      display: inline-block;
      float: left;
      width: 550px;
      height: 260px;
      padding: 10px;
      margin-left: 10px;
    }

    .card-action {
      display: inline-block;
      float: left;
      width: 160px;
      height: 260px;
    }
}
</style>